import { FunctionComponent } from 'react';
import { PageContainer } from '../../../components/PageContainer';
import { TopBar } from '../../../components/TopBar';
import { DetailsAndJourney } from './DetailsAndJourney';

export const NervaProgram: FunctionComponent = () => (
  <PageContainer testId="nerva-program-screen">
    <TopBar title="Nerva" subtitle="IBS" showReferralButton />
    <DetailsAndJourney />
  </PageContainer>
);
